export const removeNulls = <S>(value: S | undefined): value is S => value != null
